import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import ActionDialog from '../action-dialog'
import i18n from '../../../assets/i18n'
import * as S from './styled'
import Checkbox from '@material-ui/core/Checkbox'
import {basename, downloadUrl} from "../../../utils/url";

const ModalDownloadFiles = ({ handleClose, open, files }) => {
  const [checkedFiles, setCheckedFiles] = React.useState([])
  const disabledDownload = checkedFiles.length === 0 ? true : false

  const handleChange = key => {
    const existsKeyIndex = _.indexOf(checkedFiles, key)

    if (existsKeyIndex === -1) {
      setCheckedFiles([...checkedFiles, key])
    } else {
      setCheckedFiles(checkedFiles.filter(e => e !== key))
    }
  }

  const handleOnClickDownload = () => {
    _.map(checkedFiles, (fileId) => {
      const fileUrl = _.get(files, `${fileId}.url`, '')
      if (fileUrl) {
        downloadUrl(fileUrl)
      }
    })
  }

  const formatFiles = _.map(files, (file, key) => {
    const fileLabel = _.get(file, 'label', '')
    const fileUrl = _.get(file, 'url', '')
    const isChecked = _.indexOf(checkedFiles, key) > -1 ? true : false
    const fileName = decodeURIComponent(basename(fileUrl))
    return (
      <S.FileRow key={key}>
        <Checkbox
          checked={isChecked}
          onChange={() => {
            handleChange(key)
          }}
          color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
        />
        <label className="file-name">
          <span className="file-label">{fileLabel}:</span> <a href={fileUrl} target="_blank" rel="noopener noreferrer">{fileName}</a>
        </label>
      </S.FileRow>
    )
  })

  return (
    <ActionDialog
      open={open}
      title={i18n.modalDownloadFiles.title}
      onClose={handleClose}
      onConfirm={handleOnClickDownload}
      cancelLabel={i18n.dialog.decline}
      confirmLabel="Descargar seleccionados"
      confirmDisabled={disabledDownload}
    >
      <S.Body>{formatFiles}</S.Body>
    </ActionDialog>
  )
}

ModalDownloadFiles.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  files: PropTypes.array
}

export default ModalDownloadFiles
